import React, { useState, useEffect } from 'react';
import './AdhaarPay.css'
import { BASE_URL_APISERVICES  , BASE_URL_AEPS} from '../../../utils/Constants';
import { API_ENDPOINTS } from '../../../utils/apiEndpoints';
import { adminAuth } from '../../../config';

export default function MatmRecon() {
    const { username1, password1 } = adminAuth;
    const [apiData, setApiData] = useState(null);
    const [threeWayLoading, setThreeWayLoading] = useState(false);
    const [totalCount, setTotalCount] = useState(0);
    const [countLabel, setCountLabel] = useState("Total Report Count");
    const [data, setData] = useState([]);
    const [loading, setTransactionLoaderState] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");

    const getYesterdayDate = () => {
        const date = new Date();
        date.setDate(date.getDate() - 1);
        return date.toISOString().split('T')[0];
    };

    const yesterdayStr = getYesterdayDate();


    const [startDate, setStartDate] = useState(yesterdayStr);
    const [endDate, setEndDate] = useState(yesterdayStr);


    const formatDisplayDate = (dateStr) => {
        const date = new Date(dateStr);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };


    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    const formattedDateDisplay = yesterday.toLocaleDateString('en-US', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    });





    const fetchVendorPaymentsReport = async () => {
        try {
            setTransactionLoaderState(true);
            setCountLabel("Total Report Count");
            setSuccessMessage("");
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append(
                "Authorization",
                "Basic " + Buffer.from(username1 + ":" + password1).toString("base64")
                );
                

            const raw = JSON.stringify({
                userid: "",
                adminId: 10,
                fromDate: startDate,
                toDate: endDate,
            });

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow",
            };

            const response = await fetch(
                `${BASE_URL_APISERVICES}${API_ENDPOINTS.GET_MATM_REPORT}`,
                requestOptions
            );

            const apiResponse = await response.json();

            if (apiResponse.responseCode === "00" && Array.isArray(apiResponse.data)) {
                const convertedData = apiResponse.data

                    .filter(item => item.service === "WDLS")

                    .map(item => ({
                        merchantTransactionId: item.tid,
                        fingpayTransactionId: item.rch_payu_id,
                        transactionRrn: item.bank_rrn,
                        responseCode: item.status === "Y" ? "00" : "Fail",
                        transactionDate: formatDisplayDate(item.date),
                        serviceType: "CW"
                    }));
                console.log(convertedData)

                setData(convertedData);
                setTotalCount(convertedData.length);
            } else {
                setData([]);
                setTotalCount(0);
            }
        } catch (error) {
            console.error("Error in fetching report:", error);
            setData([]);
            setTotalCount(0);
        } finally {
            setTransactionLoaderState(false);
        }
    };




    const threeWayRecon = async (payloadData) => {
        if (!payloadData || payloadData.length === 0) return;
        try {
            setThreeWayLoading(true);
            setSuccessMessage("");
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: JSON.stringify(payloadData),
                redirect: "follow",
            };

            const response = await fetch(`${BASE_URL_AEPS}${API_ENDPOINTS.THREEWAY_RECON_MATM}`,
                requestOptions
            );

            const result = await response.json();
            setApiData(result)

            if (result && result.apiStatus === true && Array.isArray(result.data)) {
                setTotalCount(result.data.length);
                setCountLabel("Total 3WayRecon Count");
                setSuccessMessage("Successfully Posted all transactions");
                console.log("Count Updated from Recon API:", result.data.length);
            }


        } catch (error) {
            console.error("Second API Failed:", error);
        } finally {
            setThreeWayLoading(false);
        }
    };




    useEffect(() => {
        fetchVendorPaymentsReport();
    }, [startDate, endDate]);



  return (
      <div className="matm-page-wrapper">
          <div className="matm-card">
              <h1 className="matm-title">Matm Recon</h1>

              <div className="date-grid-container">
                  <div>
                      <label className="date-label-small">From Date</label>
                      <input
                          type="date"
                          value={startDate}
                          onChange={(e) => setStartDate(e.target.value)}
                          className="matm-date-input"
                      />
                  </div>
                  <div>
                      <label className="date-label-small">To Date</label>
                      <input
                          type="date"
                          value={endDate}
                          onChange={(e) => setEndDate(e.target.value)}
                          className="matm-date-input"
                      />
                  </div>
              </div>

              <div className="matm-footer">
                  <div className="matm-stats">
                      <span className="matm-stats-label">Date</span>
                      <span className="matm-stats-date">{formattedDateDisplay}</span>
                      <div className="matm-count-row">
                          <p className="matm-count-label">{countLabel} :</p>
                          <span className="matm-count-value">{totalCount}</span>
                      </div>
                  </div>

                  <button
                      onClick={() => threeWayRecon(data)}
                      disabled={threeWayLoading || data.length === 0 || loading}
                      className={`matm-btn ${(threeWayLoading || data.length === 0 || loading)
                              ? 'matm-btn-disabled'
                              : 'matm-btn-active'
                          }`}
                  >
                      {threeWayLoading ? (
                          <span className="flex items-center gap-2" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                              <svg className="animate-spin" style={{ height: '16px', width: '16px', color: 'white' }} viewBox="0 0 24 24">
                                  <circle style={{ opacity: 0.25 }} cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none"></circle>
                                  <path style={{ opacity: 0.75 }} fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                              </svg>
                              Processing...
                          </span>
                      ) : 'Submit'}
                  </button>
              </div>

              {successMessage && (
                  <div className="matm-success-alert">
                      <svg style={{ height: '20px', width: '20px', color: '#22c55e' }} fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                      </svg>
                      <p style={{ color: '#166534', fontWeight: '600', fontSize: '14px' }}>{successMessage}</p>
                  </div>
              )}

              {apiData && (
                  <div className="matm-response-area">
                      <p className="matm-stats-label" style={{ marginBottom: '8px' }}>Response Data:</p>
                      <div className="matm-pre-box">
                          <pre style={{ whiteSpace: 'pre-wrap', color: 'black', fontFamily: 'monospace', fontSize: '12px' }}>
                              {JSON.stringify(apiData, null, 2)}
                          </pre>
                      </div>
                  </div>
              )}
          </div>
      </div>
  )
}